export function unwrapPaginatedResponse<R>(paginatedResponse: {
    results: R[];
    pagination: { page: number; size: number; total: number };
}): R[] {
    return paginatedResponse.results;
}
